(function($, Global) {
    var BtnLogoutComponent = function(model) {
        this.model = model;
    }

	BtnLogoutComponent.prototype.initEvents = function() {
        this.publishers();
    }

	BtnLogoutComponent.prototype.publishers = function() {
        var self = this;

        $(document).on('click', '#logout', function() {
            self.model.logout();    
        });
    }

	Global.BtnLogoutComponent = BtnLogoutComponent;
}(jQuery, window));